
const settings = {
	postsPerPage: 16,
};
export const SETTINGS = settings;

export const FIELD_TYPE_TAXONOMY = 'diviner_taxonomy_field';
export const FIELD_TYPE_CPT = 'diviner_cpt_field';
export const FIELD_TYPE_SELECT = 'diviner_select_field';
export const FIELD_TYPE_TEXT = 'diviner_text_field';
export const FIELD_TYPE_DATE = 'diviner_date_field';
export const FIELD_PROP_FIELD_ID = 'field_id';
export const FIELD_PROP_FIELD_TYPE = 'field_type';
export const FIELD_PROP_HELPER = 'helper';
export const FIELD_PROP_ID = 'id';
export const FIELD_PROP_POSITION = 'position';
export const FIELD_PROP_TITLE = 'title';
export const FIELD_PROP_DISPLAY_IN_POPUP = 'display_in_popup';
export const FIELD_PROP_CPT_ID = 'cpt_field_id';
export const FIELD_PROP_CPT_LABEL = 'cpt_field_label';
export const FIELD_PROP_CPT_SLUG = 'cpt_field_slug';
export const FIELD_PROP_TAXONOMY_NAME = 'taxonomy_field_name';
export const FIELD_PROP_TAXONOMY_PLURAL_LABEL = 'taxonomy_field_plural_label';
export const FIELD_PROP_TAXONOMY_SINGULAR_LABEL = 'taxonomy_field_singular_label';
export const FIELD_PROP_TAXONOMY_SLUG = 'taxonomy_field_slug';
export const FIELD_PROP_TAXONOMY_TYPE = 'taxonomy_field_type';
export const FIELD_PROP_SELECT_OPTIONS = 'select_field_options';
export const FIELD_PROP_SELECT_OPTIONS_LABEL = 'div_field_select_options_label';
export const FIELD_PROP_SELECT_OPTIONS_VALUE = 'div_field_select_options_value';
export const FIELD_DATE_TYPE = 'date_field_type';
export const FIELD_DATE_START = 'date_field_start';
export const FIELD_DATE_END = 'date_field_end';
export const FIELD_DATE_TYPE_CENTURY = 'div_field_date_type_century';
export const FIELD_DATE_TYPE_DECADE = 'div_field_date_type_decade';
export const FIELD_DATE_TYPE_YEAR = 'div_field_date_type_year';
export const FIELD_DATE_TYPE_TWO_DATE = 'div_field_date_type_two_date';
export const FIELD_DATE_MIN_YEAR_DEFAULT = 1800;
export const FIELD_DATE_MAX_YEAR_DEFAULT = 2018;
export const FIELD_POSITION_TOP = 'top';
export const FIELD_POSITION_LEFT = 'left';
export const IMAGE_SIZE_BROWSE_POPUP = 'image_size_browse_popup';
export const IMAGE_SIZE_BROWSE_GRID = 'image_size_browse_grid';
export const DIV_AI_TYPE_PHOTO = 'div_ai_field_photo';
export const DIV_AI_TYPE_AUDIO = 'div_ai_field_audio';
export const DIV_AI_TYPE_DOCUMENT = 'div_ai_field_document';
export const DIV_AI_TYPE_VIDEO = 'div_ai_field_video';
export const DIV_AI_TYPE_MIXED = 'div_ai_field_mixed';



// WEBPACK FOOTER //
// ./src/config/settings.js